import {
    getProduct,
    listProductLineItems
} from './queries';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateProductLineItem,
    DeleteProductLineItem,
    GetProductLineItem,
    ListProductLineItems,
    ProductLineItem,
    UpdateProductLineItem
} from "../types.ts";
import {
    notifyError,
    notifySuccess
} from "../../../components/PlatformNotification";
import {generateClient} from "aws-amplify/api";
import {
    createProductLineItem,
    deleteProductLineItem,
    updateProductLineItem
} from "./mutations.ts";
import {ListRecordsQuery} from "../../../types";
import {moduleConfig} from "../config";


const client = generateClient();


export const fetchRecords = async (query: ListRecordsQuery & { productId: string }) => {
    try {
        const response = await client.graphql<GraphQLQuery<ListProductLineItems>>({
            query: listProductLineItems,
            variables: {
                productId: query.productId,
                limit: query.limit,
                sort: query.sort,
                nextToken: query.nextToken
            }
        });
        
        return {
            items: response.data?.listProductLineItems.items,
            nextToken: response.data?.listProductLineItems.nextToken
        };
    } catch (e) {
        console.trace(e);
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetProductLineItem>>({
                                                                                    query: getProduct,
                                                                                    variables: {id: id},
                                                                                });
        return response.data?.getProductLineItem;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreateProductLineItem>>({
                                                                                       query: createProductLineItem,
                                                                                       variables: {input: payload},
                                                                                   });
        console.debug('in the service response', response);
        notifySuccess(`${moduleConfig.titles.singular} created`);
        return response.data?.createProductLineItem;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const update = async (id: string, record: ProductLineItem) => {

    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;

    try {
        const response = await client.graphql<GraphQLQuery<UpdateProductLineItem>>({
                                                                                       query: (updateProductLineItem),
                                                                                       variables: {input: record},
                                                                                   });
        notifySuccess(`${moduleConfig.titles.singular} updated`)
        return response.data?.updateProductLineItem;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteProductLineItem>>({
                                                                                       query: (deleteProductLineItem),
                                                                                       variables: {input: {id: id}},

                                                                                   });
        notifySuccess(`${moduleConfig.titles.singular} deleted`)
        return response.data?.deleteProductLineItem;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};
